<template>
  <section class="operation-panel" :class="{ 'is-dock': dock }">
    <template v-if="dock">
      <GroundStationMissionPanel :plane="plane" embedded compact :expanded="activePanel === 'mission'" @open-details="restorePanel('mission')" @close-details="closePanel" @focus-route="$emit('focus-route', $event)">
        <template #compact="mission">
          <div class="compact-operation-bar">
            <div class="compact-summary"><strong>{{ plane ? plane.name : $t('等待选择飞机') }} · {{ $t(mission.title) }}</strong><span :title="$t(mission.info)">{{ $t(mission.info) }}</span></div>
            <GroundStationMissionTimeline
              class="compact-progress"
              :active="mission.progressActive"
              :ready="mission.ready"
              :progress="mission.progress"
              :delivery-progress="mission.deliveryProgress"
              :has-mission="mission.hasMission"
              :step="mission.step"
              :result="mission.result"
            />
            <div class="compact-bar-actions">
            <UiButton :title="$t('悬停')" :aria-label="$t('悬停')" :disabled="!plane" @click="$refs.dockFlight.sendCommand('{loiterMode:1}', '悬停')"><i class="iconfont compact-flight-icon icon-fengzheng1" aria-hidden="true"></i><span class="compact-action-text">{{ $t("悬停") }}</span></UiButton>
            <UiButton tone="warning" class="compact-rtl" :title="$t('返航')" :aria-label="$t('返航')" :disabled="!plane" @click="$refs.dockFlight.confirmFlightCommand('rtl')"><i class="iconfont compact-flight-icon icon-yijianfanhang" aria-hidden="true"></i><span class="compact-action-text">{{ $t("返航") }}</span></UiButton>
            </div><div class="compact-bar-actions">
            <UiButton ref="missionEntry" :title="$t('任务详情')" :aria-label="$t('任务详情')" :aria-expanded="activePanel === 'mission'" @click="switchPanel('mission')"><i class="compact-entry-icon iconfont icon-songcanfuwu" aria-hidden="true"></i><span class="compact-action-text">{{ $t("任务") }}<span class="compact-long-label">{{ $t("详情") }}</span></span><UiCountBadge :count="pendingMissionCount" /></UiButton>
            <UiButton ref="flightEntry" :title="$t('飞行控制')" :aria-label="$t('飞行控制')" :aria-expanded="activePanel === 'flight'" @click="switchPanel('flight')"><i class="compact-entry-icon iconfont icon-youxishoubing" aria-hidden="true"></i><span class="compact-action-text">{{ $t("飞行") }}<span class="compact-long-label">{{ $t("控制") }}</span></span></UiButton>
            <UiButton v-if="hasPeripheral" ref="peripheralEntry" :title="$t('外设控制')" :aria-label="$t('外设控制')" :aria-expanded="activePanel === 'peripheral'" @click="switchPanel('peripheral')"><i class="compact-entry-icon iconfont icon-linghuokuozhan" aria-hidden="true"></i><span class="compact-action-text">{{ $t("外设") }}</span></UiButton>
            </div>
          </div>
        </template>
      </GroundStationMissionPanel>
      <transition name="workbench-detail"><aside v-show="activePanel === 'flight'" class="compact-details" :aria-label="$t('飞行控制')">
        <header class="compact-details-header"><h2>{{ $t("飞行控制") }}</h2><UiIconControl variant="ghost" :title="$t('关闭飞行控制')" icon="el-icon-close" @click="closePanel" /></header>
        <div class="compact-details-body"><p class="compact-plane-status">{{ plane ? plane.name : $t('未选择飞机') }} · {{ $t(onlinePlane ? '在线' : '离线，状态可能延迟') }}</p><GroundStationQuickControlPanel ref="dockFlight" :plane="plane" :show-tabs="false" embedded /></div>
      </aside></transition>
      <transition name="workbench-detail"><aside v-if="activePanel === 'peripheral' && hasPeripheral" class="compact-details" :aria-label="$t('外设控制')">
        <header class="compact-details-header"><h2>{{ $t("外设控制") }}</h2><UiIconControl variant="ghost" :title="$t('关闭外设控制')" icon="el-icon-close" @click="closePanel" /></header>
        <div class="compact-details-body"><p class="compact-plane-status">{{ plane ? plane.name : $t('未选择飞机') }} · {{ $t(onlinePlane ? '在线' : '离线，状态可能延迟') }}</p><GroundStationPeripheralControlPanel :plane="plane" embedded /></div>
      </aside></transition>
    </template>
    <template v-else>
    <!-- 当前任务、飞行控制和外设控制共用同一级切换栏。 -->
    <div class="operation-tabs ui-tab-list" :style="tabGridStyle">
      <UiTabButton class="mission-tab-button" :class="{ 'has-count': pendingMissionCount > 0 }" :active="activePanel === 'mission'" @click="switchPanel('mission')">
        <span>{{ $t("当前任务") }}</span><UiCountBadge class="mission-tab-badge" :count="pendingMissionCount" />
      </UiTabButton>
      <UiTabButton :active="activePanel === 'flight'" @click="switchPanel('flight')">{{ $t("飞行控制") }}</UiTabButton>
      <UiTabButton v-if="hasPeripheral" :active="activePanel === 'peripheral'" @click="switchPanel('peripheral')">{{ $t("外设控制") }}</UiTabButton>
    </div>

    <div class="operation-content-stage">
      <transition name="operation-deal" mode="out-in">
        <GroundStationMissionPanel
          v-if="activePanel === 'mission'"
          key="mission"
          class="operation-content"
          :plane="plane"
          embedded
          @focus-route="$emit('focus-route', $event)"
        />
        <GroundStationQuickControlPanel
          v-else-if="activePanel === 'flight'"
          key="flight"
          class="operation-content"
          :plane="plane"
          :show-tabs="false"
          embedded
        />
        <GroundStationPeripheralControlPanel v-else key="peripheral" class="operation-content" :plane="plane" embedded />
      </transition>
    </div>
    </template>
  </section>
</template>

<script>
import GroundStationMissionPanel from '@/components/ground-station/GroundStationMissionPanel'
import GroundStationMissionTimeline from '@/components/ground-station/GroundStationMissionTimeline'
import GroundStationQuickControlPanel from '@/components/ground-station/GroundStationQuickControlPanel'
import GroundStationPeripheralControlPanel from '@/components/ground-station/GroundStationPeripheralControlPanel'
import { speakText } from '@/utils/index'
import { hasPeripheralModule } from '@/utils/planeModules'
import { getAssignableOrdersForPlane } from '@/utils/operationalStatus'

export default {
  name: 'GroundStationOperationPanel',
  components: {
    GroundStationMissionTimeline,
    GroundStationMissionPanel,
    GroundStationQuickControlPanel,
    GroundStationPeripheralControlPanel
  },
  props: {
    plane: { type: Object, default: null },
    dock: { type: Boolean, default: false }
  },
  data () {
    return { activePanel: this.dock ? '' : 'mission' }
  },
  computed: {
    onlinePlane () { return this.plane?.planeState?.online ? this.plane : null },
    hasPeripheral () { return hasPeripheralModule(this.plane) },
    pendingMissionCount () {
      return getAssignableOrdersForPlane(this.$store.state.paidOrderList, this.plane).length
    },
    tabCount () { return 2 + Number(this.hasPeripheral) },
    tabGridStyle () { return { gridTemplateColumns: `repeat(${this.tabCount}, minmax(0, 1fr))` } }
  },
  watch: {
    activePanel (panel) { if (this.dock) this.$emit('panel-change', Boolean(panel)) },
    'plane.id' () { if (this.dock) this.activePanel = '' },
    plane: {
      immediate: true,
      handler () {
        if (this.activePanel === 'peripheral' && !this.hasPeripheral) this.activePanel = 'mission'
      }
    },
    hasPeripheral (available) {
      if (!available && this.activePanel === 'peripheral') this.activePanel = 'mission'
    }
  },
  mounted () { document.addEventListener('keydown', this.onEscape) },
  beforeDestroy () { document.removeEventListener('keydown', this.onEscape) },
  methods: {
    onEscape (event) {
      if (event.target?.closest?.('.el-dialog__wrapper, .el-message-box__wrapper')) return
      if (event.key === 'Escape' && this.dock && this.activePanel) this.closePanel()
    },
    closePanel () {
      const entry = this.$refs[`${this.activePanel}Entry`]
      if (this.$refs.dockFlight) this.$refs.dockFlight.closeLockSlider()
      this.activePanel = ''
      this.$nextTick(() => entry?.$el?.focus())
    },
    restorePanel (panel) {
      if (this.dock && !panel) { this.activePanel = ''; return }
      if (panel === 'mission') this.activePanel = panel
      else if (panel === 'peripheral' && this.hasPeripheral) this.activePanel = panel
      else if (panel === 'flight') this.activePanel = panel
    },
    switchPanel (panel) {
      if (this.activePanel === panel) { if (this.dock) this.closePanel(); return }
      if (panel === 'peripheral' && !this.hasPeripheral) return
      if (this.$refs.dockFlight) this.$refs.dockFlight.closeLockSlider()
      this.activePanel = panel
      speakText({ mission: '当前任务', flight: '飞机控制', peripheral: '外设控制' }[panel])
    }
  }
}
</script>

<style lang="scss" scoped>
.operation-panel.is-dock { padding: 0; position: static; height: 64px; }
.compact-operation-bar { position: relative; z-index: 41; display: flex; align-items: center; gap: 12px; height: 64px; padding: 0 16px; box-sizing: border-box; }
.compact-summary { display: grid; gap: 5px; flex: 0 1 220px; min-width: 100px; }
.compact-summary strong, .compact-summary span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.compact-summary strong { font-size: 14px; font-weight: 600; }
.compact-summary span { font-size: 12px; color: var(--ui-text-secondary); }
.compact-progress { flex: 1 1 200px; min-width: 160px; margin: 0; }
/* 原型的细描边按钮仅用于此作业栏与详情，保留全站控件的其他变体。 */
.is-dock .compact-operation-bar ::v-deep .ui-button,
.is-dock ::v-deep .compact-details .ui-button { min-width: 44px; height: 44px; min-height: 44px; margin: 0; padding: 0 12px; border: 1px solid var(--ui-border-color) !important; border-radius: 8px; background: transparent !important; color: var(--ui-text-primary) !important; box-shadow: none !important; font-size: 13px !important; font-weight: 400 !important; }
.compact-operation-bar ::v-deep .ui-button { flex-shrink: 0; }
.compact-operation-bar ::v-deep .ui-button > span { display: inline-flex; align-items: center; gap: 6px; }
.compact-bar-actions { display: flex; gap: 6px; flex-shrink: 0; }
.compact-action-text { display: inline-flex; }
.is-dock .compact-operation-bar ::v-deep .ui-button:not(:disabled):not(.compact-primary) .compact-action-text { color: var(--skin-frame-text); }
.compact-flight-icon, .compact-entry-icon { font-size: 16px; line-height: 1; }
.is-dock .compact-operation-bar ::v-deep .compact-primary { background: var(--ui-action-primary) !important; color: var(--ui-action-primary-ink) !important; border-color: var(--ui-action-primary) !important; font-weight: 600 !important; }
.is-dock .compact-operation-bar ::v-deep .ui-button[aria-expanded="true"], .is-dock ::v-deep .compact-details .ui-button.is-active { background: var(--ui-bg-elevated) !important; border-color: var(--ui-border-color-strong) !important; }
.is-dock .compact-operation-bar ::v-deep .ui-button--tone-warning, .is-dock ::v-deep .compact-details .ui-button--tone-warning { color: var(--ui-color-warning) !important; }
.is-dock .compact-operation-bar ::v-deep .compact-rtl:not(:disabled) { color: var(--ui-color-white) !important; }
.is-dock ::v-deep .compact-details .ui-button--tone-danger { color: var(--ui-color-danger) !important; }
.is-dock .compact-operation-bar ::v-deep .ui-button:disabled, .is-dock ::v-deep .compact-details .ui-button:disabled { background: var(--ui-bg-elevated) !important; color: var(--ui-text-disabled) !important; border-color: var(--ui-border-color) !important; opacity: 1; }
.is-dock ::v-deep .compact-details { position: absolute; z-index: 40; top: 36px; right: 0; bottom: 64px; width: 360px; max-width: 100%; max-height: none; display: flex; flex-direction: column; box-sizing: border-box; padding: 0; background: var(--ui-surface-finish), var(--ui-bg-panel); border: 0; border-left: 1px solid var(--ui-border-color); border-radius: 0; box-shadow: -8px 0 24px rgba(var(--ui-color-black-rgb), .2); }
.is-dock ::v-deep .compact-details-header { flex-shrink: 0; min-height: 52px; display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 0 16px; border-bottom: 1px solid var(--ui-border-color); }
.is-dock ::v-deep .compact-details-header h2 { margin: 0; font-size: 16px; font-weight: 600; }
.is-dock ::v-deep .compact-details-header .ui-icon-control { width: 44px; height: 44px; border: 1px solid var(--ui-border-color); border-radius: 8px; background: transparent; color: var(--ui-text-secondary); }
.is-dock ::v-deep .compact-details-body { min-height: 0; flex: 1; overflow-y: auto; padding: 8px 16px 16px; font-size: 13px; }
.compact-plane-status { margin: 0 0 12px; font-size: 12px; line-height: 1.7; color: var(--ui-text-secondary); }
.is-dock ::v-deep .control-grid, .is-dock ::v-deep .device-grid { padding: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
.is-dock ::v-deep .lock-control-slot { grid-column: auto; }
.is-dock ::v-deep .lock-control-slot > .is-hidden, .is-dock ::v-deep .fuse-control-slot > .is-hidden { display: none; }
.is-dock ::v-deep .device-grid .ui-button { width: 100%; grid-column: auto; }
.is-dock ::v-deep .control-button > span, .is-dock ::v-deep .device-grid .ui-button > span, .is-dock ::v-deep .fuse-button > span { display: inline-flex; flex-direction: row; align-items: center; justify-content: center; gap: var(--ui-space-xs); }
.is-dock ::v-deep .compact-details .control-button > span { min-width: 0; white-space: normal; line-height: 1.1; }
.is-dock ::v-deep .compact-details .control-button > span > span { min-width: 0; text-align: center; }
.is-dock ::v-deep .compact-details .control-button, .is-dock ::v-deep .compact-details .device-grid .ui-button { padding: 0 8px; }
.is-dock ::v-deep .compact-details .device-grid .ui-button { padding: 0 4px; font-size: 12px !important; }
.is-dock ::v-deep .compact-details .device-grid .ui-button > span { gap: 3px; }
.is-dock ::v-deep .compact-details .device-grid .ui-button i { font-size: 14px; }
.is-dock ::v-deep .control-button i, .is-dock ::v-deep .device-grid .ui-button i, .is-dock ::v-deep .fuse-button i, .is-dock ::v-deep .cargo-actions .ui-button i { display: inline-block; flex-shrink: 0; font-size: 16px; font-weight: 400; color: inherit; }
.terminal-layout.is-ground-station .operation-panel.is-dock ::v-deep .compact-details .control-button:not(:disabled) { color: var(--ui-color-white) !important; }
.is-dock ::v-deep .compact-details .control-button:not(:disabled) i { color: var(--ui-color-primary); }
.is-dock ::v-deep .compact-details .control-button.ui-button--tone-warning:not(:disabled) i { color: var(--ui-color-warning); }
.is-dock ::v-deep .compact-details .control-button.ui-button--tone-danger:not(:disabled) i { color: var(--ui-color-danger); }
.is-dock ::v-deep .compact-details .device-grid .ui-button:not(:disabled) i { color: var(--ui-color-primary); }
.is-dock ::v-deep .compact-details .device-grid .ui-button.ui-button--tone-neutral:not(:disabled) i { color: var(--ui-text-secondary); }
.is-dock ::v-deep .compact-details .device-grid .ui-button.ui-button--tone-warning:not(:disabled) i { color: var(--ui-color-warning); }
.is-dock ::v-deep .compact-details .device-grid .ui-button.ui-button--tone-danger:not(:disabled) i { color: var(--ui-color-danger); }
.is-dock ::v-deep .compact-details .fuse-button:not(:disabled) i { color: var(--ui-color-danger); }
.is-dock ::v-deep .device-section { padding: 0; margin: 0; border: 0; background: transparent; }
.is-dock ::v-deep .device-title { min-height: 0; margin: 0 0 12px; padding: 0; font-size: 14px; font-weight: 600; }
.is-dock ::v-deep .device-title > span:first-child::before { display: none; }
.is-dock ::v-deep .mission-summary-tile { padding: 0; }
.is-dock ::v-deep .mission-order-select-shell { margin-top: 0; padding-top: 0; gap: var(--ui-space-sm); }
.is-dock ::v-deep .mission-order-step { font-size: 12px; line-height: 1.7; }
.is-dock ::v-deep .mission-title { margin-bottom: var(--ui-space-sm); }
.is-dock ::v-deep .mission-title strong { font-size: 14px; }
.is-dock ::v-deep .mission-order-select .el-input__inner { min-height: 44px; font-size: 13px; }
.is-dock ::v-deep .mission-timeline__point.reached { box-shadow: none; }
.is-dock ::v-deep .mission-timeline__progress line { stroke: var(--ui-action-primary); }
@media (hover: hover) and (pointer: fine) {
  .is-dock .compact-operation-bar ::v-deep .ui-button:not(:disabled):hover, .is-dock ::v-deep .compact-details .ui-button:not(:disabled):hover { background: var(--ui-bg-elevated) !important; border-color: var(--ui-border-color-strong) !important; }
}
@media (max-width: 1366px) and (min-height: 541px) and (orientation: landscape) {
  .is-dock ::v-deep .compact-details { width: 216px; }
  .is-dock ::v-deep .compact-details-header { padding: 0 12px; }
  .is-dock ::v-deep .compact-details-body { padding: 8px 12px 12px; }
}
@media (max-height: 540px) and (orientation: landscape) {
  .compact-operation-bar { gap: 4px; padding: 0 8px; }
  .compact-bar-actions { gap: 4px; }
  .compact-summary { flex-basis: 130px; min-width: 60px; }
  .compact-summary strong { font-size: 12px; }
  .compact-summary span { font-size: 11px; }
  .compact-progress { flex-basis: 140px; min-width: 100px; }
  .compact-long-label, .compact-entry-icon, .compact-flight-icon { display: none; }
  .is-dock .compact-operation-bar ::v-deep .ui-button { padding: 0 8px; font-size: 12px !important; }
  .is-dock ::v-deep .compact-details { top: auto; left: 0; right: 0; width: auto; height: min(200px, 55%); max-height: none; border-left: 0; border-top: 1px solid var(--ui-border-color); box-shadow: 0 -8px 24px rgba(var(--ui-color-black-rgb), .2); }
  .is-dock ::v-deep .compact-details-header { min-height: 44px; padding: 0 12px; }
  .is-dock ::v-deep .compact-details-header h2 { font-size: 14px; }
  .is-dock ::v-deep .compact-details-body { padding: 8px 12px 12px; }
  .is-dock ::v-deep .control-grid, .is-dock ::v-deep .device-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}
@media (max-width: 700px) and (max-height: 540px) and (orientation: landscape) {
  .compact-summary { min-width: 40px; }
  .compact-progress { min-width: 64px; flex-basis: 64px; }
}
.operation-panel { padding: 0 var(--ui-space-sm) var(--ui-space-md); overflow: visible; }
.operation-tabs { width: 100%; display: grid; margin-bottom: var(--ui-space-sm); overflow: visible; animation: operation-section-deal-in .34s cubic-bezier(.2, .76, .24, 1) 180ms both; }
.operation-tabs button { gap: var(--ui-space-xs); font-size: var(--gs-font-heading, 12px); font-weight: var(--gs-weight-medium, 500); line-height: 1.2; letter-spacing: .45px; }
.mission-tab-button { position: relative; overflow: visible; }
.mission-tab-button.has-count { z-index: 3; }
.mission-tab-badge { position: absolute; z-index: 3; top: -2px; right: -2px; }
.operation-content { width: 100%; box-sizing: border-box; }
.operation-content-stage { animation: operation-section-deal-in .36s cubic-bezier(.2, .76, .24, 1) 250ms both; }
.operation-deal-enter-active { animation: operation-panel-in .16s ease-out both; }
.operation-deal-leave-active { animation: operation-panel-out .12s ease-in both; }
@keyframes operation-panel-in { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: none; } }
@keyframes operation-panel-out { to { opacity: 0; transform: translateY(3px); } }
@keyframes operation-section-deal-in { from { opacity: 0; transform: translate3d(18px, -7px, 0) rotate(1deg) scale(.98); } to { opacity: 1; transform: none; } }

/* 展开态切换 Tab 时，内部区块沿用折叠小窗的逐项发牌节奏。 */
.operation-deal-enter-active ::v-deep .mission-title,
.operation-deal-enter-active ::v-deep .mission-timeline,
.operation-deal-enter-active ::v-deep .mission-order-select,
.operation-deal-enter-active ::v-deep .mission-card > dl,
.operation-deal-enter-active ::v-deep .mission-warnings,
.operation-deal-enter-active ::v-deep .mission-actions,
.operation-deal-enter-active ::v-deep .cargo-actions,
.operation-deal-enter-active ::v-deep .control-button:not(.lock-swap-button),
.operation-deal-enter-active ::v-deep .device-section,
.operation-deal-enter-active ::v-deep .empty-device {
  animation: operation-content-deal-in .34s cubic-bezier(.18, .76, .24, 1) both;
}

.operation-deal-enter-active ::v-deep .mission-title,
.operation-deal-enter-active ::v-deep .control-button:nth-child(1),
.operation-deal-enter-active ::v-deep .device-section:nth-child(1),
.operation-deal-enter-active ::v-deep .empty-device { animation-delay: 45ms; }

.operation-deal-enter-active ::v-deep .mission-timeline,
.operation-deal-enter-active ::v-deep .control-button:nth-child(2),
.operation-deal-enter-active ::v-deep .device-section:nth-child(2) { animation-delay: 100ms; }

.operation-deal-enter-active ::v-deep .mission-order-select,
.operation-deal-enter-active ::v-deep .mission-card > dl,
.operation-deal-enter-active ::v-deep .control-button:nth-child(3),
.operation-deal-enter-active ::v-deep .device-section:nth-child(3) { animation-delay: 155ms; }

.operation-deal-enter-active ::v-deep .mission-warnings,
.operation-deal-enter-active ::v-deep .control-button:nth-child(4),
.operation-deal-enter-active ::v-deep .device-section:nth-child(4) { animation-delay: 210ms; }

.operation-deal-enter-active ::v-deep .mission-actions,
.operation-deal-enter-active ::v-deep .control-button:nth-child(5) { animation-delay: 265ms; }

.operation-deal-enter-active ::v-deep .cargo-actions,
.operation-deal-enter-active ::v-deep .control-button:nth-child(6) { animation-delay: 320ms; }

.operation-deal-enter-active ::v-deep .control-button:nth-child(7) { animation-delay: 375ms; }

@keyframes operation-content-deal-in {
  from {
    opacity: 0;
    transform: translate3d(18px, 9px, 0) rotate(1.4deg) scale(.96);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) rotate(0) scale(1);
  }
}
</style>
